export default "__VITE_ASSET__Db7GrAh0__"